import { render, staticRenderFns } from "./PersonalityAssessment.vue?vue&type=template&id=157433d0"
import script from "./PersonalityAssessment.vue?vue&type=script&lang=js"
export * from "./PersonalityAssessment.vue?vue&type=script&lang=js"
import style0 from "./PersonalityAssessment.vue?vue&type=style&index=0&id=157433d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports